import Code from "../../../components/code";
import DocsAuthor from "../../components/docsAuthor";
export const advancedToolsPage = {
  title: "Advanced and Security",
  sections: [
    {
      id: "stale",
      name: "Stale Dependency Check",
    },
    {
      id: "sandbox",
      name: "Isolated Sandbox Environment",
    },
  ],
  content: (
    <>
      <DocsAuthor nickname="StrayVibes" publishedAt="June 10, 2025 at 13:08 AM" />
      <section id="stale">
        <h2>⏳ Stale Dependency Check - Keep Your Project Fresh!</h2>
        <p>
          Don't let your project rely on forgotten code! 🕵️‍♂️ The{" "}
          <Code>meow stale</Code> command helps you identify dependencies that
          might be unmaintained or inactive. It checks their last publish date
          on npm and their GitHub repository for recent commits.
        </p>
        <Code fullWidth>meow stale</Code>
        <p>
          This is crucial for preventing <strong>security vulnerabilities</strong> and
          ensuring your project uses <strong>well-supported packages</strong>. Keep your
          project vibrant and secure! ✨🛡️
        </p>
      </section>
      <section id="sandbox">
        <h2>📦 Isolated Sandbox Environment - Test with Confidence!</h2>
        <p>
          Need to test a command or script in a truly clean environment? 🧪 The
          <Code>meow sandbox</Code> command creates a temporary, isolated
          workspace for your project and provides an interactive shell.
        </p>
        <Code fullWidth>meow sandbox</Code>
        <p>
          Once inside, you can run any command in this clean setup. Use
          <Code>sandbox destroy</Code> to clean up the environment or{" "}
          <Code>sandbox open</Code> to view its directory. 🚀📁
        </p>
      </section>
    </>
  ),
};
